import type { MobileOrDesktop } from '../deviceType/types';

const CREDIT_CARDS_PREFIX = 'credit-cards';
const DEVICE_SEGMENTS: MobileOrDesktop[] = ['desktop', 'mobile'];
// Inlined from ABTestVariant to avoid circular dependency with platform-absmartly
const EXPERIMENT_SEGMENTS = ['control', 'treatment', 'treatment1', 'treatment2'];
type DeviceType = (typeof DEVICE_SEGMENTS)[number];
type BucketingDecision = (typeof EXPERIMENT_SEGMENTS)[number];

/**
 * For documentation on this regex, see the following link:
 * @see https://regex101.com/r/sinSih/1
 */
const deviceAndExperimentRegex = new RegExp(
  `^/${CREDIT_CARDS_PREFIX}/(.+?)(?:/(${DEVICE_SEGMENTS.join('|')}))?(?:/(${EXPERIMENT_SEGMENTS.join('|')}))?$`,
);

export function parseCanonicalPathname(pathname: string): string {
  const match = pathname.match(deviceAndExperimentRegex);
  if (match) {
    const slug = match[1];
    const isDeviceTypeSlug = DEVICE_SEGMENTS.includes(slug as DeviceType);
    const isSubsequentParamBucketingDecision = EXPERIMENT_SEGMENTS.includes(
      match[2] as BucketingDecision,
    );
    const canonicalSlug = isDeviceTypeSlug && isSubsequentParamBucketingDecision ? 'best' : slug;
    return `/${CREDIT_CARDS_PREFIX}/${canonicalSlug}`;
  }
  return pathname;
}
